import { render, staticRenderFns } from "./DonorVideoDisclaimer.vue?vue&type=template&id=99b540b8"
import script from "./DonorVideoDisclaimer.vue?vue&type=script&lang=js"
export * from "./DonorVideoDisclaimer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports